<template>
  <v-expansion-panels :value="0" flat>
    <v-expansion-panel>
      <v-expansion-panel-header class="py-0 pl-1 align-start text-selection">
        <div @click="handleHeaderClick">
          <v-container class="py-0">
            <v-row>
              <v-col>
                <h3 v-if="countGuias > 1">Guias de faturamento ({{ countGuias }})</h3>
                <h3 v-else>Guia de faturamento</h3>
              </v-col>
            </v-row>

            <v-row v-if="countGuias" align="start">
              <v-col class="py-0" cols="6">
                <div>BENEFICIÁRIO</div>
                <div
                  v-for="(carteira, index) in carteirinhas"
                  :key="index"
                >
                  <template v-if="carteira">
                    <b>{{ carteira }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
                <div
                  class="mt-1"
                  v-for="(beneficiario, index) in beneficiarios"
                  :key="index"
                >
                  <template v-if="beneficiario">
                    <b>{{ beneficiario }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
              </v-col>

              <v-col class="py-0">
                <div>SENHA</div>
                <div
                  v-for="(senha, index) in senhas"
                  :key="index"
                >
                  <template v-if="senha">
                    <b>{{ senha | formatNullValue }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
              </v-col>
              <v-col class="py-0">
                 <div>GUIA OPERADORA</div>
                 <div
                   v-for="(guia, index) in guiasOperadora"
                   :key="index"
                 >
                   <template v-if="guia">
                     <b>{{ guia | formatNullValue }}</b>
                   </template>
                   <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                   <span v-else>-</span>
                 </div>              
                </v-col>
            </v-row>
            <v-row v-if="countGuias">
              <v-col class="py-2">
                <div>CRONOGRAMA</div>
                <div
                  v-for="(cronograma, index) in cronogramas"
                  :key="index"
                >
                  <template v-if="cronograma">
                    <b>{{ cronograma | formatDate | formatNullValue }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
              </v-col>
              <v-col class="py-2">
                <div>DATA INÍCIO FATURAMENTO</div>
                <div
                  v-for="(dataInicioFat, index) in dataInicioFaturamento"
                  :key="index"
                >
                  <template v-if="dataInicioFat">
                    <b>{{ dataInicioFat | formatDate | formatNullValue }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
              </v-col>
              <v-col class="py-2">
                <div>DATA FIM FATURAMENTO</div>
                <div
                  v-for="(dataFimFat, index) in dataFimFaturamento"
                  :key="index"
                >
                  <template v-if="dataFimFat">
                    <b>{{ dataFimFat | formatDate | formatNullValue }}</b>
                  </template>
                  <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
                  <span v-else>-</span>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="!countGuias">
              <v-col>
                <v-container class="text-center text-uppercase">
                  Selecione pelo menos uma guia de faturamento para conciliar os itens
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content v-if="countGuias">
        <v-container class="py-2 px-4">
          <v-row>
            <v-col>
              <div>{{ countGuias > 1 ? 'TOTAL INFORMADO' : 'VALOR INFORMADO' }}</div>
              <div class="font-weight-bold">{{ totalInformado | currency }}</div>
            </v-col>
            <v-col>
              <div>{{ countGuias > 1 ? 'TOTAL PAGO' : 'VALOR PAGO' }}</div>
              <div class="font-weight-bold success--text">{{ totalPago | currency }}</div>
            </v-col>
            <v-col>
              <div>{{ countGuias > 1 ? 'TOTAL GLOSADO' : 'VALOR GLOSADO' }}</div>
              <div class="font-weight-bold red--text">{{ totalGlosado | currency }}</div>
            </v-col>
            <v-col>
              <div>{{ countGuias > 1 ? 'SALDO TOTAL' : 'SALDO' }}</div>
              <div class="font-weight-bold">{{ saldo | currency }}</div>
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.text-selection {
  user-select: text;
}
</style>

<script>
import { mapState } from 'vuex'
import { formatCurrency, sessionStorageClient } from '../../../libs'

export default {
  methods: {
    handleHeaderClick (event) {
      if (window?.getSelection()?.toString()) {
        event.stopPropagation()
        return
      }
    }
  },
  computed: {
    ...mapState('conciliacao', ['selectedFaturamentoGuias']),
    faturamentoGuiaIds () {
      return Object.keys(this.selectedFaturamentoGuias).sort()
    },
    countGuias () {
      return this.faturamentoGuiaIds.length
    },
    beneficiarios () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].nomeBeneficiario)
    },
    carteirinhas () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].numeroCarteira)
    },
    datasExecucao () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].dataExecucao)
    },
    cronogramas () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].lote.cronograma.dataFaturamento)
    },
    senhas () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].senha)
    },
     guiasOperadora () {
       return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].numeroGuiaOperadora)
     },
    dataInicioFaturamento () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].dataInicioFaturamento)
    },
    dataFimFaturamento () {
      return this.faturamentoGuiaIds.map(id => this.selectedFaturamentoGuias[id].dataFimFaturamento)
    },
    totalInformado () {
      return this.faturamentoGuiaIds.reduce((total, id) => total + this.selectedFaturamentoGuias[id].valorTotal, 0)
    },
    totalPago () {
      return this.faturamentoGuiaIds.reduce((total, id) => total + this.selectedFaturamentoGuias[id].valorPago, 0)
    },
    totalGlosado () {
      return this.faturamentoGuiaIds.reduce((total, id) => total + this.selectedFaturamentoGuias[id].valorGlosa, 0)
    },
    totalAcatado () {
      return this.faturamentoGuiaIds.reduce((total, id) => total + this.selectedFaturamentoGuias[id].valorAcatado, 0)
    },
    saldo () {
      var valorResult =this.totalInformado - this.totalPago - this.totalAcatado
      return valorResult < 0 ? 0 : valorResult
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    }
  },
  filters: {
    currency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
